/* eslint-disable array-bracket-newline */
/**
 * Recent trades tab, if there are any - than redirect back
 */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import format from 'date-fns/format';
import { IDexTrade } from '@kattana-io/common';
import Loader from '../../../common/Loader';
import Text from '../../../../atoms/Text';
import Image from '../../../../atoms/Image';
import refresh from '../../../../assets/images/refresh.svg';
import big_arrow_left from '../../../../assets/images/arrow_left.svg';
import { toFixed4 } from '../../../DexTrades/formatters';
import { formatPriceUSD } from '../../../Modal/TickersModal/helper';
import { formatTokenName } from '../../../../helpers/formatters';
import { ETabs, ICoin } from '../../reducers/tradingReducer';
import { KattanaAPI } from '../../../../store/createStore';
import { IStore } from '../../../../reducers';

import './styles.scss';

const isBuy = (side: number, flipped: boolean) => {
  let buy = true;
  if (side === 1) {
    if (flipped) {
      buy = false;
    }
  } else {
    if (!flipped) {
      buy = false;
    }
  }

  return buy;
};

interface iprops {
  setTab: (tab: ETabs) => void;
  account: string | undefined | null;
  base: ICoin;
  quote: ICoin;
  dexChainId: number | undefined;
  tab: ETabs;
}

const selector = (state: IStore) => state.current;

const RecentTrades = ({ setTab, account }: iprops) => {
  const {
    chain,
    address,
    base,
    quote,
    base_decimals,
    quote_decimals,
    flipped,
  } = useSelector(selector);
  const [trades, setTrades] = useState<IDexTrade[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (loading && account) {
      setLoading(true);
      const controller = new AbortController();

      KattanaAPI.walletTrades(account, address, chain, controller)
        .then((response: IDexTrade[] | null) => {
          setTrades(response ? response : []);
          setLoading(false);
        })
        .catch((err: any) => {
          console.warn(err);
          setTrades([]);
          setLoading(false);
        });
    }
  }, [loading, account, chain, address]);

  return (
    <div className='container'>
      <div className='row'>
        <div className='simple_tab_selector'>
          <div
            className='simple_tab_selector simple_tab_selector--clickable'
            onClick={() => setTab(ETabs.Swap)}
          >
            <Image size='s' src={big_arrow_left} />
            <Text size={12} className='simple_tab_selector__tab'>
              Swap
            </Text>
          </div>
          <div
            className='simple_tab_selector__tab'
            onClick={() => setTab(ETabs.Limit)}
          >
            <Text size={12}>Limit</Text>
          </div>
        </div>
        <div className='control'>
          <Image src={refresh} size='s' onClick={() => setLoading(true)} />
        </div>
      </div>
      <div className='recent_trades'>
        {loading && (
          <div className='centrify'>
            <Loader />
          </div>
        )}
        {!loading && (
          <>
            <div className='recent_trades__caption'>Recent Transactions</div>
            {trades.map((trade: IDexTrade, index: number) => {
              const formatedDate = format(
                new Date(trade.timestamp * 1000),
                'dd-MMM-yyyy'
              );
              const buy = isBuy(trade.buy, flipped);
              const amount = buy
                ? Number(trade.amount0) / 10 ** base_decimals
                : Number(trade.amount1) / 10 ** quote_decimals;
              const priceUSD = formatPriceUSD(
                flipped ? trade.price_b_usd : trade.price_a_usd
              );
              const baseToken = formatTokenName(flipped ? quote : base);
              const quoteToken = formatTokenName(flipped ? base : quote);
              return (
                <div className='recent_trades__trade' key={index}>
                  <div className='recent_trades__trade__date'>
                    {formatedDate}
                  </div>
                  <div className='recent_trades__trade__data'>
                    <div
                      className={`recent_trades__trade__data__header recent_trades__trade__data__header--${
                        buy ? 1 : 0
                      }`}
                    >
                      <span>{buy ? 'buy' : 'sell'}</span>
                    </div>
                    <div className='recent_trades__trade__data__row'>
                      <span>Price {baseToken}</span>
                      <div>{priceUSD}</div>
                    </div>
                    <div className='recent_trades__trade__data__row'>
                      <span>Amount {buy ? quoteToken : baseToken}</span>
                      <div>{toFixed4(amount)}</div>
                    </div>
                    <div className='recent_trades__trade__data__row'>
                      <span>Tx Value</span>
                      <div>{trade.value_usd} $</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
};

export default RecentTrades;
